import { BlockCreateInvoiceActionReason } from '../../../enums/blockCreateInvoiceActionReason'

interface ReasonTranslationKey {
  closeButton: string
  confirmButton: string
  description: string
  title: string
}

export const reasonToTranslationKey: Record<BlockCreateInvoiceActionReason, ReasonTranslationKey> = {
  [BlockCreateInvoiceActionReason.FinalInvoiceDraftAlreadyExists]: {
    closeButton: 'close',
    confirmButton: 'quotes.view.create_final_invoice_action_blocked_modal.go_to_final_invoice',
    description: 'quotes.view.create_final_invoice_action_blocked_modal.by_existing_final_invoice.description',
    title: 'quotes.view.create_final_invoice_action_blocked_modal.by_existing_final_invoice.title',
  },
  [BlockCreateInvoiceActionReason.DepositInvoiceDraftExists]: {
    closeButton: 'return',
    confirmButton: 'quotes.view.create_invoice_action_blocked_modal.by_draft_deposit_invoice.create_invoice',
    description: 'quotes.view.create_invoice_action_blocked_modal.by_draft_deposit_invoice.description',
    title: 'quotes.view.create_invoice_action_blocked_modal.by_draft_deposit_invoice.title',
  },
  [BlockCreateInvoiceActionReason.RegularInvoiceDraftExists]: {
    closeButton: 'return',
    confirmButton: 'quotes.view.create_deposit_invoice_action_blocked_modal.by_draft_invoice.create_deposit_invoice',
    description: 'quotes.view.create_deposit_invoice_action_blocked_modal.by_draft_invoice.description',
    title: 'quotes.view.create_deposit_invoice_action_blocked_modal.by_draft_invoice.title',
  },
  [BlockCreateInvoiceActionReason.DepositInvoiceUnpaid]: {
    closeButton: 'close',
    confirmButton: 'quotes.view.create_final_invoice_action_blocked_modal.go_to_deposit_invoice',
    description: 'quotes.view.create_final_invoice_action_blocked_modal.by_unpaid_deposit_invoice.description',
    title: 'quotes.view.create_final_invoice_action_blocked_modal.by_unpaid_deposit_invoice.title',
  },
}
